/**
 * Contact form functionality.
 *
 * @author    Mark Shercliff <mark@bareface.agency>
 * @copyright 2016 Bareface
 */
;(function($, window, undefined) {
    $('#gform_1 [name="input_1"]').change(function() {
      var locale = $(this).val();
      $('.contact-details__locale').fadeOut(function() {
        setTimeout(function() {
          $('.contact-details__locale--' + locale).fadeIn();
        });
      })
    });
})(jQuery, window);
